import React from "react";
import { logFeatureUsage } from "../../lib/analytics/AnalyticsController";
import { getJsonData } from "data/DataStore";
import { getTitleUi } from "data/TitleInfoSelector";
import { getDisplayName } from 'lib/higherOrderComponentsUtility';

/**
 * Adds logging functionality to a component.
 * Gets the source id from the data store when it is not supplied.
 *
 *
 * @param {*} Component The component to add the logged onClick prop to
 * @param {string} featureType The feature type to log
 * @param {*} getDestId A string, number, or function for the destination Id
 * If this is a function it will be called passing in the props and should return the id
 * @param {*} getSrcId A string, number, or function for the destination Id
 * If this is a function it will be called passing in the props and should return the id
 * @returns The Component passed in with an onClick property
 */
export function withLogFeatureUsage(Component, featureType, getDestId, getSrcId) {
	function handleClick(props) {
		let destId;
		let srcId = getTitleUi(getJsonData());
		const defaultTypes = ['string', 'number'];

		if (getDestId) {
			if (defaultTypes.includes(typeof getDestId)) {
				destId = getDestId;
			} else {
				destId = getDestId(props);
			}
		}

		if (getSrcId) {
			if (defaultTypes.includes(typeof getSrcId)) {
				srcId = getSrcId;
			} else {
				srcId = getSrcId(props);
			}
		}

		logFeatureUsage(featureType, srcId, destId);
	}

	let WithOnClickLogFeature = (props) => (
		<Component
			{...props}
			onClick={() => {
				handleClick(props);

				if (props.onClick) {
					props.onClick();
				}
			}}
		/>
	);

	WithOnClickLogFeature.displayName = `withOnClickLogFeature(${getDisplayName(Component)})`;

	return WithOnClickLogFeature;
}

export default withLogFeatureUsage;



// WEBPACK FOOTER //
// ./src/react/containers/AnalyticContainer.jsx